import Create from "./Create";
import Edit from "./Edit";
import List from "./List";

const routes = [
    {
        path: 'vendors',
        element: <List />
    },
    {
        path: 'vendors/create',
        element: <Create />
    },
    {
        path: 'vendors/edit/:id',
        element: <Edit />
    }
]
export default routes;